module.exports = __webpack_public_path__ + "static/media/text_icon_1.68378bdd.svg";